import { LOBBY_SOCKET_CONNECTED, LOBBY_SOCKET_PENDING } from '@/Poker/data/Constants';
import { useSelector } from 'react-redux'

export default function useLobbyConnectionStatus() {
    const connectionStatus = useSelector((state) => state.lobby.connection);

    return { connected: connectionStatus === LOBBY_SOCKET_CONNECTED || connectionStatus === LOBBY_SOCKET_PENDING, connectionStatus: connectionStatus }
}
